var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconInfo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeWidth: 0.999,
  d: "M15.774 8.274a7.5 7.5 0 1 1-15.001 0 7.5 7.5 0 0 1 15.001 0Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeWidth: 0.874,
  d: "M10.242 3.679c0 .447-.4.863-.963.863s-.963-.416-.963-.863.4-.863.963-.863.963.416.963.863Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeWidth: 0.999,
  d: "m5.68 7.177.146-.598c.486-.199 1.548-.597 1.898-.597 1.87-.06 2.045 1.17 1.899 1.793-.244.996-.774 3.198-.95 4.035 0 .837 1.071.598 1.607.374 0 .1-.015.373-.073.672-.238.122-.712.273-1.114.389a3.625 3.625 0 0 1-1.004.135c-1.694 0-1.825-1.346-1.68-2.018l.877-3.587c.234-1.016-.974-.822-1.606-.598Z"
})));
export default SvgIconInfo;